"use client";

import type { FC } from "react";

import { Content as BuilderContent } from "@builder.io/sdk-react";

import { env } from "@/env";

import { filterComponentsByContent } from "../components-registry/componentLazyRegistry";
import { useBuilderPreview } from "../context/BuilderPreviewContext";

import { ContentErrorFallback } from "./ContentErrorFallback";
import type { ContentProps } from "./ContentProps";

export const SafeBuilderContent: FC<ContentProps> = ({ fallback, ...props }) => {
  const previewState = useBuilderPreview();

  const customComponents =
    previewState.mode === "authoring" ? previewState.components : filterComponentsByContent(props.content);

  // try-catch catches runtime errors that might not be React rendering related
  // e.g. if component get a wrong properties and crashes due to undefined value access
  try {
    return (
      <BuilderContent
        {...props}
        key={previewState.mode}
        apiKey={env.builderApiKey}
        customComponents={customComponents}
        enrich={true}
      />
    );
  } catch (error) {
    console.error("Builder Content Runtime Error:", error);
    return fallback || <ContentErrorFallback />;
  }
};
